<template>
  <div>
    <!-- Desktop View -->
    <div class="desktop-view">
      <!-- Seção de Filtros -->
      <div class="card mb-3">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>ID</label>
                <input
                  v-model="filters.id"
                  type="text"
                  class="form-control"
                  placeholder="Digite o ID"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Checklist</label>
                <v-select
                  v-model="filters.checklist"
                  :options="checklistOptions"
                  label="nome"
                  placeholder="Selecione"
                  :reduce="(checklist) => checklist.checklist_template_id"
                >
                  <template #no-options>Nenhum checklist encontrado</template>
                </v-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Unidade</label>
                <v-select
                  v-model="filters.unit"
                  :options="unitOptions"
                  label="name"
                  placeholder="Selecione"
                  :reduce="(unit) => unit.id"
                >
                  <template #no-options>Nenhuma unidade encontrada</template>
                </v-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Grupo</label>
                <v-select
                  v-model="filters.group"
                  :options="groupOptions"
                  label="group_nome"
                  placeholder="Selecione"
                  :reduce="(group) => group.group_id"
                >
                  <template #no-options>Nenhum grupo encontrado</template>
                </v-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Data</label>
                <input
                  v-model="filters.date"
                  type="date"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Status</label>
                <select v-model="filters.status" class="form-control">
                  <option :value="null">Todos</option>
                  <option :value="2">Finalizada</option>
                  <option :value="3">Não Preenchida</option>
                  <option :value="4">Parcialmente preenchida</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-2"
              v-show="
                $store.state.user.perfil_id === 1 ||
                $store.state.user.perfil_id === 6 ||
                $store.state.user.perfil_id === 7
              "
            >
              <div class="form-group">
                <label>Usuário</label>
                <v-select
                  v-model="filters.user"
                  :options="userOptions"
                  label="usuario_nome"
                  placeholder="Selecione"
                  :reduce="(user) => user.usuario_id"
                >
                  <template #no-options>Nenhum usuário encontrado</template>
                </v-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Observação</label>
                <input
                  v-model="filters.observacao"
                  type="text"
                  class="form-control"
                  placeholder="Digite a observação"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>&nbsp;</label>
                <div class="d-flex">
                  <button @click="applyFilters" class="btn btn-primary mr-2">
                    <i class="fas fa-search"></i> Filtrar
                  </button>
                  <button @click="clearFilters" class="btn btn-secondary mr-2">
                    <i class="fas fa-times"></i> Limpar
                  </button>
                  <button
                    @click="exportExcel"
                    class="btn btn-success"
                    :disabled="exportingExcel"
                  >
                    <i class="fas fa-file-excel"></i>
                    {{ exportingExcel ? "Exportando..." : "Exportar Excel" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-crud
            :key="crudKey"
            ref="historicoCrud"
            crudName="Histórico de Checklists"
            newText="Nova Execução"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="true"
            :enableView="true"
            :enableReset="false"
            :dataForm="dataForm"
          >
          </base-crud>
        </div>
      </div>
    </div>

    <!-- Mobile View -->
    <div class="mobile-view">
      <div class="mobile-header">
        <h1 class="mobile-title">Histórico de Checklists</h1>
      </div>

      <div v-if="loading" class="text-center p-4">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else class="mobile-cards-container">
        <div
          v-for="execution in executions"
          :key="execution.checklist_execution_id"
          class="checklist-card"
        >
          <!-- Card Header -->
          <div class="card-header-line">
            <div class="id-badge">#{{ execution.checklist_execution_id }}</div>
            <div :class="['status-badge', getStatusClass(execution.status)]">
              {{ getStatusText(execution.status) }}
            </div>
          </div>

          <!-- Card Body -->
          <div class="card-body">
            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-clipboard-list"></i>
                CHECKLIST
              </div>
              <div class="info-value">
                {{
                  execution.checklist_template
                    ? execution.checklist_template.nome
                    : "N/A"
                }}
              </div>
            </div>

            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-map-marker-alt"></i>
                UNIDADE
              </div>
              <div class="info-value">
                {{
                  execution.unit && execution.unit.name
                    ? execution.unit.name
                    : "N/A"
                }}
              </div>
            </div>

            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-users"></i>
                GRUPO
              </div>
              <div class="info-value">
                {{ execution.grupo_nome || "N/A" }}
              </div>
            </div>

            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-user"></i>
                USUÁRIO
              </div>
              <div class="info-value">
                {{ execution.usuario ? execution.usuario.usuario_nome : "N/A" }}
              </div>
            </div>

            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-calendar"></i>
                DATA/HORA
              </div>
              <div class="info-value">
                {{ formatDate(execution.data_execucao) }}
              </div>
            </div>

            <div
              class="card-info-row"
              v-if="
                execution.observacao &&
                (!execution.checklist_template ||
                  execution.checklist_template.exibir_observacao !== false)
              "
            >
              <div class="info-label">
                <i class="fas fa-comment"></i>
                OBSERVAÇÃO
              </div>
              <div class="info-value">
                {{ execution.observacao }}
              </div>
            </div>
          </div>

          <!-- Card Footer -->
          <div
            class="card-footer"
            v-if="
              canView(execution.status) ||
              (execution.status === 4 &&
                execution.usuario_id == currentUserId &&
                !isExpired(execution.data_expiracao))
            "
          >
            <button
              v-if="
                execution.status === 4 &&
                execution.usuario_id == currentUserId &&
                !isExpired(execution.data_expiracao)
              "
              class="btn-resume"
              @click="retomarExecution(execution.checklist_execution_id)"
            >
              <i class="fas fa-play"></i>
              Retomar
            </button>
            <button
              v-if="canView(execution.status)"
              class="btn-execute"
              @click="viewExecution(execution.checklist_execution_id)"
            >
              <i class="fas fa-eye"></i>
              Visualizar Execução
            </button>
          </div>
        </div>

        <div v-if="!loading && executions.length === 0" class="no-data-message">
          <i class="fas fa-inbox fa-3x"></i>
          <p>Nenhuma execução encontrada</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    BaseCrud,
    vSelect,
  },

  data() {
    return {
      crudKey: 0,
      table: "checklistExecutionsTable",
      showMessageImport: false,
      pages: [],
      url: "",
      columns: [
        "checklist_execution_id",
        "checklist_template.nome",
        "unit.name",
        "grupo_nome",
        "usuario.usuario_nome",
        "data_execucao",
        "status",
        "observacao",
        "actions",
      ],
      tableData: [
        "checklist_execution_id",
        "checklist_template.nome",
        "unit.name",
        "grupo_nome",
        "usuario.usuario_nome",
        "data_execucao",
        "status",
        "observacao",
      ],
      endPoint: "checklistexecutions",
      dataForm: {},

      // Mobile view data
      executions: [],
      loading: false,
      exportingExcel: false,

      // Filtros customizados
      filters: {
        id: null,
        checklist: null,
        unit: null,
        group: null,
        user: null,
        date: null,
        status: null,
        observacao: null,
      },
      checklistOptions: [],
      unitOptions: [],
      groupOptions: [],
      userOptions: [],

      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          //   "checklist_execution_id",
          //   "checklist_template.nome",
          //   "unit.name",
          //   "usuario.usuario_nome",
          //   "data_execucao",
          //   "status",
          //   "observacao",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          checklist_execution_id: "ID",
          "checklist_template.nome": "Checklist",
          "unit.name": "Unidade",
          grupo_nome: "Grupo",
          "usuario.usuario_nome": "Usuário",
          data_execucao: "Data/Hora",
          status: "Status",
          observacao: "Observação",
          actions: "Ações",
        },
        sortable: [
          "checklist_execution_id",
          "checklist_template.nome",
          "unit.name",
          "usuario.usuario_nome",
          "data_execucao",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
      },
    };
  },

  computed: {
    currentUserId() {
      return this.$store.state.user.usuario_id;
    },
  },

  created() {
    this.buildTemplates();
    this.loadFilterOptions();
  },

  methods: {
    async loadFilterOptions() {
      try {
        const checklistsResponse = await axios.get(
          this.$store.state.api + "checklisttemplates?paginated=false"
        );
        this.checklistOptions = checklistsResponse.data.data || [];
      } catch (error) {
        console.error("Erro ao carregar opções de checklist:", error);
      }

      try {
        const unitsResponse = await axios.get(
          this.$store.state.api + "units?paginated=false&status=1"
        );
        this.unitOptions = unitsResponse.data.data || [];
      } catch (error) {
        console.error("Erro ao carregar opções de unidade:", error);
      }

      try {
        const groupsResponse = await axios.get(
          this.$store.state.api + "groups?paginated=false&status=1"
        );
        this.groupOptions = groupsResponse.data.data || [];
      } catch (error) {
        console.error("Erro ao carregar opções de grupo:", error);
      }

      try {
        const usersResponse = await axios.get(
          this.$store.state.api + "users?paginated=false&status=1"
        );
        this.userOptions = usersResponse.data.data || [];
      } catch (error) {
        console.error("Erro ao carregar opções de usuário:", error);
      }
    },

    applyFilters() {
      // Forçar reconstrução da requestFunction
      this.setupCustomFilters();

      // Recarregar tabela
      this.reloadCrud();
    },

    clearFilters() {
      this.filters = {
        id: null,
        checklist: null,
        unit: null,
        group: null,
        user: null,
        date: null,
        status: null,
        observacao: null,
      };
      this.reloadCrud();
    },
    buildTemplates() {
      // Remover requestFunction customizada para usar o padrão
      delete this.options.requestFunction;

      this.options.templates = {
        "checklist_template.nome": (h, row) => {
          return row.checklist_template ? row.checklist_template.nome : "N/A";
        },

        "unit.name": (h, row) => {
          return row.unit ? row.unit.name : "N/A";
        },

        grupo_nome: (h, row) => {
          return row.grupo_nome || "N/A";
        },

        "usuario.usuario_nome": (h, row) => {
          return row.usuario ? row.usuario.usuario_nome : "N/A";
        },

        data_execucao: (h, row) => {
          if (row.data_execucao) {
            const date = new Date(row.data_execucao);
            return date.toLocaleString("pt-BR");
          }
          return "";
        },

        status: (h, row) => {
          // Mapear status numéricos para texto
          const statusMap = {
            0: "Disponível",
            1: "Aguardando preenchimento",
            2: "Finalizada",
            3: "Não preenchida",
            4: "Parcialmente preenchida",
            // Manter compatibilidade com strings antigas se necessário
            finalizada: "Finalizada",
            nao_respondida: "Não respondida",
            incompleta: "Incompleta",
          };

          const badgeClassMap = {
            0: "badge-info",
            1: "badge-warning",
            2: "badge-success",
            3: "badge-danger",
            4: "badge-warning",
            // Compatibilidade com strings antigas
            finalizada: "badge-success",
            nao_respondida: "badge-danger",
            incompleta: "badge-warning",
          };

          const statusText = statusMap[row.status] || row.status;
          const badgeClass = badgeClassMap[row.status] || "badge-secondary";

          return h(
            "span",
            {
              class: `badge ${badgeClass}`,
              style: { fontSize: "0.9em", padding: "0.4em 0.8em" },
            },
            statusText
          );
        },

        observacao: (h, row) => {
          if (
            row.checklist_template &&
            row.checklist_template.exibir_observacao === false
          ) {
            return "—";
          }
          if (row.observacao && row.observacao.trim() !== "") {
            return row.observacao.length > 50
              ? row.observacao.substring(0, 50) + "..."
              : row.observacao;
          }
          return "—";
        },

        actions: (h, row) => {
          const buttons = [];
          const user = this.$store.state.user;

          if (
            row.status === 4 &&
            user &&
            Number(row.usuario_id) === Number(user.usuario_id) &&
            !this.isExpired(row.data_expiracao)
          ) {
            buttons.push(
              h(
                "button",
                {
                  class: "btn btn-crud resume",
                  attrs: {
                    title: "Retomar Execução",
                    type: "button",
                  },
                  on: {
                    click: () => {
                      this.$router.push(
                        `/checklist-executions/retomar/${row.checklist_execution_id}`
                      );
                    },
                  },
                },
                [
                  h("i", {
                    class: "fas fa-play",
                  }),
                ]
              )
            );
          }

          if (
            row.status === 2 || // STATUS_FINALIZADA
            row.status === 3 || // STATUS_NAO_PREENCHIDA
            row.status === 4 || // STATUS_PARCIALMENTE_PREENCHIDA
            // Manter compatibilidade com strings antigas
            row.status === "finalizada" ||
            row.status === "nao_respondida" ||
            row.status === "incompleta"
          ) {
            buttons.push(
              h(
                "button",
                {
                  class: "btn btn-crud view",
                  attrs: {
                    title: "Visualizar",
                    type: "button",
                  },
                  on: {
                    click: () => {
                      this.$router.push(
                        `/checklist-executions/view/${row.checklist_execution_id}`
                      );
                    },
                  },
                },
                [
                  h("i", {
                    class: "fas fa-eye",
                  }),
                ]
              )
            );

            buttons.push(
              h(
                "button",
                {
                  class: "btn btn-crud pdf",
                  attrs: {
                    title: "Exportar PDF",
                    type: "button",
                  },
                  on: {
                    click: () => {
                      this.exportPdf(row.checklist_execution_id);
                    },
                  },
                },
                [
                  h("i", {
                    class: "fas fa-file-pdf",
                  }),
                ]
              )
            );
          }

          if (user && user.perfil_id === 1) {
            buttons.push(
              h(
                "button",
                {
                  class: "btn btn-crud delete",
                  attrs: {
                    title: "Deletar",
                    type: "button",
                  },
                  on: {
                    click: () => {
                      this.confirmDelete(row);
                    },
                  },
                },
                [
                  h("i", {
                    class: "far fa-trash-alt",
                  }),
                ]
              )
            );
          }

          return h("div", { style: { width: "150px" } }, buttons);
        },
      };

      // Configurar requestFunction customizada DEPOIS de montar templates
      this.$nextTick(() => {
        this.setupCustomFilters();
      });
    },

    setupCustomFilters() {
      this.options.requestFunction = (data) => {
        let filterQuery = this.buildFilterQuery();
        let apiUrl = "checklistexecutions";

        const params = [];

        if (filterQuery) {
          params.push(filterQuery);
        }

        if (data.page) {
          params.push("page=" + data.page);
        }

        if (data.limit) {
          params.push("limit=" + data.limit);
        }

        if (params.length > 0) {
          apiUrl += "?" + params.join("&");
        }

        return this.$http
          .get(apiUrl)
          .then((response) => {
            return response;
          })
          .catch((e) => {
            console.error("Erro na requisição:", e);
            if (e.response) {
              console.error("Status:", e.response.status);
              console.error("Dados:", e.response.data);
            }
            this.$notify &&
              this.$notify({
                type: "error",
                title: "Erro",
                text: "Erro ao carregar registros",
              });
            return Promise.resolve({ data: { data: [], count: 0 } });
          });
      };
    },

    buildFilterQuery() {
      let filterArray = [];

      // Aplicar filtros customizados
      if (this.filters.id && this.filters.id.trim() !== "") {
        const filterId = `CAST(checklist_execution_id AS TEXT) LIKE '%${this.filters.id}%'`;
        filterArray.push(filterId);
      }
      if (this.filters.checklist) {
        const filterChecklist = `CAST(checklist_template_id AS INTEGER) = ${this.filters.checklist}`;
        filterArray.push(filterChecklist);
      }
      if (this.filters.unit) {
        const filterUnit = `CAST(unit_id AS INTEGER) = ${this.filters.unit}`;
        filterArray.push(filterUnit);
      }
      if (this.filters.group) {
        const filterGroup = `CAST(usuario_id AS INTEGER) IN (SELECT usuario_id FROM app.tb_usuario WHERE group_id = ${this.filters.group})`;
        filterArray.push(filterGroup);
      }
      if (this.filters.user) {
        const filterUser = `CAST(usuario_id AS INTEGER) = ${this.filters.user}`;
        filterArray.push(filterUser);
      }
      if (this.filters.date && this.filters.date.trim() !== "") {
        const filterDate = `DATE(data_execucao) = '${this.filters.date}'`;
        filterArray.push(filterDate);
      }
      if (
        this.filters.status !== null &&
        this.filters.status !== "" &&
        this.filters.status !== undefined
      ) {
        const filterStatus = `status = ${this.filters.status}`;
        filterArray.push(filterStatus);
      }
      if (this.filters.observacao && this.filters.observacao.trim() !== "") {
        const filterObs = `(observacao ILIKE '%${this.filters.observacao}%' AND CAST(checklist_template_id AS INTEGER) IN (SELECT checklist_template_id FROM app.tb_checklist_templates WHERE exibir_observacao = true))`;
        filterArray.push(filterObs);
      }

      const filters = filterArray.join(" AND ");
      return filters ? encodeURI("filter=" + filters) : "";
    },

    async exportExcel() {
      this.exportingExcel = true;
      try {
        const filterQuery = this.buildFilterQuery();
        let apiUrl = "checklistexecutions/export-excel";

        if (filterQuery) {
          apiUrl += "?" + filterQuery;
        }

        const response = await this.$http.get(apiUrl, { responseType: "blob" });

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "historico_checklists.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar Excel:", error);
        swal("Erro", "Não foi possível exportar o Excel.", "error");
      } finally {
        this.exportingExcel = false;
      }
    },

    async exportPdf(id) {
      try {
        const response = await this.$http.get(
          `checklistexecutions/${id}/export-pdf`,
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `checklist_execution_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar PDF:", error);
        swal("Erro", "Não foi possível exportar o PDF.", "error");
      }
    },

    confirmDelete(row) {
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        cancelButtonText: "Não",
      }).then((value) => {
        if (value === true || value === "confirm") {
          this.deleteExecution(row.checklist_execution_id);
        }
      });
    },

    async deleteExecution(id) {
      try {
        const apiUrl = this.$store.state.api + "checklistexecutions/" + id;

        await axios.delete(apiUrl);

        swal("Sucesso", "Registro excluído com sucesso!", "success");

        this.reloadCrud();
      } catch (error) {
        console.error("Erro ao deletar:", error);

        swal("Erro", "Erro ao deletar o registro!", "error");
      }
    },

    reloadCrud() {
      this.$nextTick(() => {
        if (
          this.$refs.historicoCrud &&
          typeof this.$refs.historicoCrud.refresh === "function"
        ) {
          this.$refs.historicoCrud.refresh();
          return;
        }

        if (
          this.$refs.historicoCrud &&
          typeof this.$refs.historicoCrud.load === "function"
        ) {
          this.$refs.historicoCrud.load();
          return;
        }

        if (
          this.$refs.historicoCrud &&
          typeof this.$refs.historicoCrud.getData === "function"
        ) {
          this.$refs.historicoCrud.getData();
          return;
        }

        this.crudKey += 1;
      });

      // Recarregar também mobile view
      this.loadExecutions();
    },

    // Mobile methods
    async loadExecutions() {
      this.loading = true;
      try {
        const apiUrl = `${this.$store.state.api}checklistexecutions`;
        const response = await axios.get(apiUrl);

        this.executions = response.data.data || response.data || [];
      } catch (error) {
        console.error("Erro ao carregar execuções:", error);
        this.executions = [];
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleString("pt-BR");
    },

    getStatusText(status) {
      const statusMap = {
        0: "Disponível",
        1: "Aguardando",
        2: "Finalizada",
        3: "Não Preenchida",
        4: "Parcial",
        finalizada: "Finalizada",
        nao_respondida: "Não Respondida",
        incompleta: "Incompleta",
      };
      return statusMap[status] || status;
    },

    getStatusClass(status) {
      const statusClassMap = {
        0: "status-disponivel",
        1: "status-aguardando",
        2: "status-finalizada",
        3: "status-nao-preenchida",
        4: "status-parcial",
        finalizada: "status-finalizada",
        nao_respondida: "status-nao-preenchida",
        incompleta: "status-parcial",
      };
      return statusClassMap[status] || "status-default";
    },

    isExpired(dataExpiracao) {
      if (!dataExpiracao) return false;
      return new Date(dataExpiracao) < new Date();
    },

    canView(status) {
      return (
        status === 2 ||
        status === 3 ||
        status === 4 ||
        status === "finalizada" ||
        status === "nao_respondida" ||
        status === "incompleta"
      );
    },

    viewExecution(id) {
      this.$router.push(`/checklist-executions/view/${id}`);
    },

    retomarExecution(id) {
      this.$router.push(`/checklist-executions/retomar/${id}`);
    },
  },

  mounted() {
    this.url = this.$store.state.api + "checklistexecutions";
    this.loadExecutions();
  },
};
</script>

<style scoped>
/* Vue Select customization */
.v-select .vs__dropdown-toggle {
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.v-select .vs__search {
  padding: 0;
  margin: 0;
}

.v-select .vs__selected {
  margin: 0;
  padding: 0;
}

/* Desktop view - sempre visível exceto no mobile */
.desktop-view {
  display: block;
}

.mobile-view {
  display: none;
}

/* === MOBILE STYLES === */
@media (max-width: 950px) {
  .desktop-view {
    display: none !important;
  }

  .mobile-view {
    display: block;
  }

  .mobile-header {
    text-align: center;
    padding: 1.5rem 1rem;
    margin-bottom: 1rem;
  }

  .mobile-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: var(--bs-body-color);
  }

  .mobile-cards-container {
    padding: 0 1rem 2rem;
  }

  /* Card Styling */
  body[data-bs-theme="light"] .checklist-card,
  .light-layout .checklist-card,
  html[data-bs-theme="light"] .checklist-card,
  :not([data-bs-theme="dark"]) .checklist-card {
    background-color: rgba(235, 235, 235, 0.311) !important;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: none;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25), 0 6px 16px rgba(0, 0, 0, 0.18);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  body[data-bs-theme="dark"] .checklist-card,
  .dark-layout .checklist-card {
    background-color: rgba(21, 22, 35, 0.8) !important;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 0 4px 12px rgba(0, 0, 0, 0.4);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .checklist-card:active {
    transform: scale(0.98);
  }

  body[data-bs-theme="dark"] .checklist-card:active,
  .dark-layout .checklist-card:active {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.7), 0 2px 8px rgba(0, 0, 0, 0.5);
  }

  .card-header-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 0;
    border-bottom: none;
  }

  body[data-bs-theme="light"] .card-header-line,
  .light-layout .card-header-line,
  html[data-bs-theme="light"] .card-header-line,
  :not([data-bs-theme="dark"]) .card-header-line {
    border-bottom: none;
  }

  .id-badge {
    font-size: 1.15rem;
    font-weight: 700;
    color: rgb(0, 140, 255);
  }

  .status-badge {
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }

  .status-disponivel {
    background: rgba(0, 123, 255, 0.15);
    color: #007bff;
    border: 1px solid rgba(0, 123, 255, 0.3);
  }

  .status-aguardando {
    background: rgba(255, 193, 7, 0.15);
    color: #ffc107;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  .status-finalizada {
    background: rgba(40, 167, 69, 0.15);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.3);
  }

  .status-nao-preenchida {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
    border: 1px solid rgba(220, 53, 69, 0.3);
  }

  .status-parcial {
    background: rgba(255, 193, 7, 0.15);
    color: #ff9800;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  .status-default {
    background: rgba(108, 117, 125, 0.15);
    color: #6c757d;
    border: 1px solid rgba(108, 117, 125, 0.3);
  }

  .card-body {
    margin-bottom: 1.5rem;
  }

  .card-info-row {
    margin-bottom: 0.85rem;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    border-left: 2px solid rgba(0, 140, 255, 0.35);
    transition: all 0.2s ease;
  }

  .card-info-row:hover {
    background: rgba(255, 255, 255, 0.07);
    border-left-color: rgba(0, 140, 255, 0.7);
  }

  .card-info-row:last-child {
    margin-bottom: 0;
  }

  body[data-bs-theme="light"] .card-info-row,
  .light-layout .card-info-row,
  html[data-bs-theme="light"] .card-info-row,
  :not([data-bs-theme="dark"]) .card-info-row {
    background: rgba(0, 0, 0, 0.03);
    border-left: 2px solid rgba(0, 140, 255, 0.3);
  }

  body[data-bs-theme="light"] .card-info-row:hover,
  .light-layout .card-info-row:hover,
  html[data-bs-theme="light"] .card-info-row:hover,
  :not([data-bs-theme="dark"]) .card-info-row:hover {
    background: rgba(0, 0, 0, 0.05);
    border-left-color: rgba(0, 140, 255, 0.6);
  }

  .info-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0, 140, 255, 0.7);
    margin-bottom: 0.4rem;
    text-transform: uppercase;
    letter-spacing: 0.8px;
  }

  .info-label i {
    font-size: 0.85rem;
    opacity: 0.6;
  }

  .info-value {
    font-size: 1rem;
    font-weight: 500;
    color: var(--bs-body-color);
    opacity: 0.9;
    padding-left: 0;
    word-break: break-word;
  }

  body[data-bs-theme="dark"] .info-value,
  .dark-layout .info-value {
    opacity: 0.85;
  }

  .card-footer {
    margin-top: 1.75rem;
    padding-top: 0;
    border-top: none;
    background: transparent;
  }

  .btn-resume {
    width: 100%;
    padding: 1rem;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, #ff9800, #e65100);
    color: white;
    font-size: 1rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(255, 152, 0, 0.35);
    margin-bottom: 0.75rem;
  }

  .btn-resume:active {
    transform: scale(0.97);
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.45);
  }

  .btn-resume i {
    font-size: 0.9rem;
  }

  .btn-execute {
    width: 100%;
    padding: 1rem;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, rgb(0, 140, 255), rgb(0, 110, 255));
    color: white;
    font-size: 1rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 140, 255, 0.3);
  }

  .btn-execute:active {
    transform: scale(0.97);
    box-shadow: 0 2px 8px rgba(0, 140, 255, 0.4);
  }

  .btn-execute i {
    font-size: 0.9rem;
  }

  .no-data-message {
    text-align: center;
    padding: 3rem 1rem;
    color: var(--bs-secondary-color);
  }

  .no-data-message i {
    margin-bottom: 1rem;
    opacity: 0.3;
  }

  .no-data-message p {
    font-size: 1.1rem;
    margin: 0;
  }
}

/* === SMALL MOBILE === */
@media (max-width: 480px) {
  .mobile-title {
    font-size: 1.5rem;
  }

  .checklist-card {
    padding: 1.25rem;
  }

  .id-badge {
    font-size: 1rem;
  }

  .status-badge {
    font-size: 0.7rem;
    padding: 0.35rem 0.75rem;
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.95rem;
  }

  .btn-execute {
    font-size: 0.95rem;
    padding: 0.9rem;
  }
}
</style>